import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { tableStyleCompact, thStyleCompact, tdStyleCompact, sectionTitleStyle } from "./printTableStyles";

export default function BhavaDataTable({ bhavaData }) {
    const { t } = useTranslation();
    return (
        <div>
            <div style={sectionTitleStyle}>
                {t("BhavaPosition")}
            </div>
            <table style={tableStyleCompact}>
                <thead>
                    <tr>
                        <th style={thStyleCompact}>{t("Bhavaya")}</th>
                        <th style={thStyleCompact}>{t("Rashiya")}</th>
                        <th style={thStyleCompact}>{t("Place")}</th>
                        <th style={thStyleCompact}>{t("Nekatha")}</th>
                        <th style={thStyleCompact}>{t("PlanetAspectsCol3")}</th>
                        <th style={thStyleCompact}>{t("BhavaUpaGraha2")}</th>
                        <th style={thStyleCompact}>{t("BhavaUpaGraha3")}</th>
                        <th style={thStyleCompact}>{t("BhavagathaGrahayo")}</th>
                    </tr>
                </thead>
                <tbody>
                    {bhavaData.map((row, idx) => (
                        <tr key={idx}>
                            <td style={tdStyleCompact}>{row.bhavaIndex}</td>
                            <td style={tdStyleCompact}>{row.rasi}</td>
                            <td style={tdStyleCompact}>{row.place}</td>
                            <td style={tdStyleCompact}>{row.nekatha}</td>
                            <td style={tdStyleCompact}>{row.upaGraha}</td>
                            <td style={tdStyleCompact}>{row.upaUpaGraha}</td>
                            <td style={tdStyleCompact}>{row.upaUpaUpaGraha}</td>
                            <td style={tdStyleCompact}>{row.gahasInBhava}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

BhavaDataTable.propTypes = {
    bhavaData: PropTypes.array.isRequired,
};
